import React, { Component } from 'react';
import request from 'request-promise-native';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import config from '../../config/config';
import ApiDetailsWrapper from './ApiDetailsWrapper';
import { getAnonymousURL, getAuthHeader } from '../../utils/service-utils';
import { types, INITIAL_STATE } from './constants';
import reducer from './ApiDetailsReducer';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import { API_TYPES } from '../../utils/constants';
const REGISTERED = 'registered';

export class ApiDetailsContainerInner extends Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.state = { ...INITIAL_STATE };
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth: { loginPending }
    } = this.props;

    if (!loginPending && !this.state.isAuthenticated) {
      this.setState({ isAuthenticated: true });
      this.getApiInfo(this.props.match.params.id);
    }
  }

  componentDidMount() {
    this.mounted = true;
    setTimeout(() => {
      this.getApiInfo(this.props.match.params.id);
    }, 300);
  }

  /* STORE API FUNCTIONS */
  dispatch = action => {
    if (this.mounted) {
      this.setState(prevState => reducer(prevState, action));
    }
  };

  thunk = (options, actions, args = {}, callback) => {
    this.dispatch({ type: actions[0], args });
    request({ ...options, json: true })
      .then(response => {
        this.dispatch({ type: actions[1], response, args });
        if (callback) {
          callback(undefined, response);
        }
      })
      .catch(error => {
        const response = error.error;
        if (response) {
          error = response;
        }
        this.dispatch({ type: actions[2], error, args });
        if (callback) {
          callback(error);
        }
      });
  };
  /* END STORE API FUNCTIONS */

  getApiInfo = apiId => {
    const apiGatewayUrl = getAnonymousURL(
      this.props.auth,
      config.api.apiGatewayUrlV2
    );
    const asyncApiServiceBaseUrl = getAnonymousURL(
      this.props.auth,
      `${config.api.asyncApiServiceBaseUrl}/v2`
    );
    const url =
      this.props.match.path === '/apis/:id'
        ? `${apiGatewayUrl}/directory/apis/${apiId}`
        : `${asyncApiServiceBaseUrl}/directory/async-apis/${apiId}`;
    const options = {
      method: 'GET',
      url: url,
      headers: { ...getAuthHeader(this.props.auth) }
    };
    this.thunk(
      options,
      [
        types.API_INFO_GET_REQUEST,
        types.API_INFO_GET_RECEIVE,
        types.API_INFO_GET_ERROR
      ],
      {},
      (undefined, response) => {
        if (response) {
          const apiTypeFromResponse = response.kind;
          this.setState({ apiType: apiTypeFromResponse });
          this.dispatch({
            type: types.API_INFO_GET_RECEIVE,
            response,
            oneToOneApiAnon: true
          });
        }
      }
    );
  };

  getDomainDisplayName = () => {
    let domainUrl = getAnonymousURL(this.props.auth, config.api.domainUrl);
    if (this.props.auth.isAuthenticated) {
      domainUrl += '/directory/groups';
    } else {
      domainUrl += `/v1/domains`;
    }
    const options = {
      method: 'GET',
      url: `${domainUrl}`,
      headers: { ...getAuthHeader(this.props.auth) }
    };
    return [];
  };

  sendEmailToProvider = payload => {
    const options = {
      method: 'POST',
      url: config.api.emailDispatcherUrl,
      headers: { ...getAuthHeader(this.props.auth) },
      body: payload,
      json: true
    };
    this.thunk(options, [
      types.SEND_EMAIL_TO_PROVIDER_GET_REQUEST,
      types.SEND_EMAIL_TO_PROVIDER_GET_RECEIVE,
      types.SEND_EMAIL_TO_PROVIDER_GET_ERROR
    ]);
  };

  sendEmailToConsumer = payload => {
    const options = {
      method: 'POST',
      url: config.api.emailDispatcherUrl,
      headers: { ...getAuthHeader(this.props.auth) },
      body: payload,
      json: true
    };
    this.thunk(options, [
      types.SEND_EMAIL_TO_CONSUMER_GET_REQUEST,
      types.SEND_EMAIL_TO_CONSUMER_GET_RECEIVE,
      types.SEND_EMAIL_TO_CONSUMER_GET_ERROR
    ]);
  };

  restrictedRequestAccess = apiId => {
    const { auth } = this.props;
    const apiGatewayUrl = getAnonymousURL(auth, config.api.apiGatewayUrl);
    const asyncApiServiceBaseUrl = getAnonymousURL(
      auth,
      `${config.api.asyncApiServiceBaseUrl}/v1`
    );
    if (!auth.isAuthenticated) {
      const currentPath = this.props.previousLocation;
      auth.login({ appState: { returnTo: currentPath } });
      return;
    }
    const apiType = this.state.apiType;
    const url =
      apiType === API_TYPES.REST
        ? `${apiGatewayUrl}/api/${apiId}/request-access`
        : `${asyncApiServiceBaseUrl}/async-api/${apiId}/request-access`;

    const options = {
      method: 'POST',
      url,
      headers: { ...getAuthHeader(auth) },
      json: true
    };
    return new Promise((resolve, reject) => {
      this.thunk(
        options,
        [
          types.RESTRICTED_ACCESS_REQUEST,
          types.RESTRICTED_ACCESS_RECEIVE,
          types.RESTRICTED_ACCESS_ERROR
        ],
        {},
        (err, response) => {
          if (err) reject(err);
          else resolve(response);
        }
      );
    });
  };

  render() {
    return (
      <React.Fragment>
        <ApiDetailsWrapper
          apiType={this.state.apiType}
          store={this.state}
          dispatch={this.dispatch}
          getApiInfo={this.getApiInfo}
          getDomainDisplayName={this.getDomainDisplayName}
          getProviders={this.getProviders}
          getProviderRatePlans={this.getProviderRatePlans}
          sendEmailToProvider={this.sendEmailToProvider}
          sendEmailToConsumer={this.sendEmailToConsumer}
          restrictedRequestAccess={this.restrictedRequestAccess}
          {...this.props}
        />
      </React.Fragment>
    );
  }
}

function withContainer(WrappedComponent) {
  return withEntityContext(ApiDetailsContainerInner);
}

export default withAuth(withContainer(withEntityContext(ApiDetailsWrapper)));
